import { useEffect } from 'react';
import ReactGa from 'react-ga4';
import { useTranslation } from 'react-i18next';

import AuthPageShell from '@/components/auth/AuthPageShell';
import ClientOnboard from '@/components/client/ClientOnboard';
import RecruiterOnboard from '@/components/recruiter/RecruiterOnboard';
import { DASHBOARD } from '@/constants/routes';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useUrlState } from '@/hooks/useUrlState';

const Onboard = () => {
  const { user, isClient, isRecruiter } = useCurrentUser();
  const [t] = useTranslation();
  const { history } = useUrlState();

  useEffect(() => {
    ReactGa.send('pageview');
    if (isRecruiter && user?.onboarding_status === 'completed') {
      history.replace(DASHBOARD);
    }
  }, [history, isRecruiter, user?.onboarding_status]);

  return (
    <AuthPageShell bannerTitle={t('GET_STARTED_LABEL')} bannerClickable={false}>
      {isClient && user?.company && (
        <ClientOnboard user={{ ...user, company: user.company }} />
      )}
      {isRecruiter && user && (
        <RecruiterOnboard user={user} standalone isOnboard />
      )}
    </AuthPageShell>
  );
};

export default Onboard;
